export const heroEditorialPremiumTopicModule = {
  name: 'heroEditorialPremiumTopic',
};
